import { observable, action, runInAction } from 'mobx'
import { message } from 'antd'
import { json } from '../../../utils/ajax'

class GoodsStore {
  @observable loading

  @observable search
  @observable list
  @observable pagination
  @observable category

  constructor () {
    this.loading = false
    this.search = {}
    this.list = []
    this.pagination = {}
    this.category = []
  }

  @action searchGoodsList = async (page) => {
    runInAction(() => {
      this.loading = true
    })
    // 服务器page参数下标从0开始
    if (page) {
      page--;
    } else if (this.pagination.page) {
      page = this.pagination.page - 1;
    } else {
      page = 0;
    }
    // 构建search参数
    let search = {}
    Object.keys(this.search).forEach(key => {
      search[`search.${key}`] = this.search[key] ? this.search[key] : ''
    })
    search.page = page

    const res = await json.get(`${process.env.REACT_APP_API_URL}/stock/goods/list`, search);
    if (res.status) {
      runInAction(() => {
        this.list = res.data.content
        this.pagination = {
          total: res.data.totalElements,
          results: res.data.size,
          page: res.data.number + 1
        }
        this.loading = false
      })
    } else {
      message.error(res.msg)
    }
  }

  @action fetchCategory = async () => {
    const res = await json.get(`${process.env.REACT_APP_API_URL}/stock/category/list`);
    if (res.status) {
      runInAction(() => {
        this.category = res.data
      })
    }
  }
}

export default new GoodsStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/Goods/store.js